import { z } from 'zod';

import { endpoint, GetEndpointType } from '@Common/types/zod/zod-endpoint';

export const ZodAnalystRating = z.enum(['strong_sell', 'sell', 'hold', 'buy', 'strong_buy']);

const ZodAnalystRatingDeltaItem = z.object({
  instrument_id: z.number(),
  old_rating: ZodAnalystRating,
  new_rating: ZodAnalystRating,
});

export type AnalystRatingDeltaItem = z.infer<typeof ZodAnalystRatingDeltaItem>;

const deltaArrayLength = 4;

export const ZodGetExploreAnalystRatingsLatestEndpointResponseBody = z.object({
  upgrades: z.array(ZodAnalystRatingDeltaItem).length(deltaArrayLength),
  downgrades: z.array(ZodAnalystRatingDeltaItem).length(deltaArrayLength),
});

export const getExploreAnalystRatingsLatestEndpoint = endpoint({
  method: 'GET',
  responseBody: ZodGetExploreAnalystRatingsLatestEndpointResponseBody,
});

export type GetExploreAnalystRatingsLatestEndpoint = GetEndpointType<
  typeof getExploreAnalystRatingsLatestEndpoint
>;
